'use client';

import { Box, Fab, styled, Tooltip } from '@mui/material';
import CookieIcon from '@mui/icons-material/Cookie';
import { useCookieConsent } from '@/app/contexts/cookie-consent-context';

export default function CookieButton() {
  const { setShowConsentManager } = useCookieConsent();

  const handleClick = () => {
    setShowConsentManager(true);
  };

  return (
    <Box>
      <Tooltip title="Cookie Einstellungen" placement="right">
        <StyledFab
          color="primary"
          size="small"
          aria-label="Cookie Einstellungen"
          onClick={handleClick}
        >
          <CookieIcon />
        </StyledFab>
      </Tooltip>
    </Box>
  );
}

const StyledFab = styled(Fab)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  border: `1px solid ${theme.palette.background.paper}`,
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
}));
